import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { COMMON_PROBLEMS } from "../../data/content";

export default function CommonProblems() {
  return (
    <section
      data-testid="common-problems"
      className="py-20 md:py-32 bg-white border-t border-ink-line"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14">
          <div className="md:col-span-7">
            <div className="font-mono text-[11px] tracking-[0.25em] uppercase text-ink-muted mb-5">
              Common issues we address
            </div>
            <h2 className="font-display text-3xl md:text-5xl text-ink leading-tight tracking-[-0.03em]">
              We help solve common
              <br />
              <span className="font-serif-italic font-normal text-ink-mid">
                property problems.
              </span>
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9 self-end">
            <Link
              to="/contact?service=inspection"
              data-testid="common-problems-cta"
              className="inline-flex items-center gap-3 text-ink hover:text-ink-soft border-b border-ink pb-1 text-[11px] tracking-[0.25em] uppercase"
            >
              Book a site inspection <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-ink-line border border-ink-line">
          {COMMON_PROBLEMS.map((p, i) => (
            <div
              key={p}
              data-testid={`problem-${i}`}
              className="bg-white p-5 md:p-6 group hover:bg-ink hover:text-white transition-colors flex flex-col justify-between min-h-[120px]"
            >
              <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-ink-muted group-hover:text-white/50">
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className="font-display text-base md:text-lg mt-4 leading-tight">
                {p}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
